<div class="h-full" [class]="floatingPageClasses()">
  <div
    [class]="
      floating()
        ? 'bg-white rounded-t-xl border border-neutral-200 px-2xl pt-2xl'
        : ''
    "
    [class.border-b-0]="floating() && !isLoading()"
    [class.rounded-b-xl]="floating() && isLoading()">
    <lib-request-details-header
      [showTrigger]="requestDetailsResponse().data.is_triggable"
      [showAddScheduleAction]="showAddScheduleAction()"
      [enableTriggerDropdown]="true"
      [showRequestId]="false"
      [requestDetailsResponse]="requestDetailsResponse()"
      [backUrl]="backPath()" />
  </div>

  @if (!isLoading()) {
    <lib-tabs
      [class]="
        floating()
          ? 'block text-neutral-700'
          : 'pb-2xl border-b border-neutral-200 text-neutral-700 mt-2xl'
      "
      [tabSegmented]="systemTabs()"
      [tabsHeaderClass]="
        floating()
          ? '!justify-start bg-white rounded-b-xl border border-t-0 border-neutral-200 px-2xl pb-lg mb-lg'
          : ''
      "
      [tabsContentClass]="floating() ? tabsContentClass : ''"
      [tabPill]="!systemTabs()"
      [enableTabRouting]="true"
      [paramKey]="DETAILS_TAB_PARAM_KEY"
      [activeTabIndex]="currentTabIndex()"
      (selectTab)="tabNavigation($event)">
      @for (tab of visibleTabs(); track $index; let index = $index) {
        <lib-tab
          [tabTitle]="tab.name"
          [tabTemplateSvgIcon]="iconTemplate"
          [tabRoutingParam]="tab.key"
          [featurePermissions]="tab.featurePermissions ?? []"
          [userPermissions]="requestDetailsResponse().data.permissions">
          <ng-template #iconTemplate>
            @switch (tab.key) {
              @case ('history') {
                <lib-clock-icon
                  [iconClass]="
                    'size-4 ' +
                    (currentTabIndex() === index
                      ? 'text-primary-500'
                      : 'text-neutral-500')
                  " />
              }

              @case ('reports') {
                <lib-reports-icon
                  [iconClass]="
                    'size-4 ' +
                    (currentTabIndex() === index
                      ? 'text-primary-500'
                      : 'text-neutral-500')
                  " />
              }

              @case ('requirements') {
                <lib-refresh-icon
                  [iconClass]="
                    'size-4 ' +
                    (currentTabIndex() === index
                      ? 'text-primary-500'
                      : 'text-neutral-500')
                  " />
              }

              @case ('steps-diagram') {
                <lib-step-diagram-icon
                  [iconClass]="
                    'size-4 ' +
                    (currentTabIndex() === index
                      ? 'text-primary-500'
                      : 'text-neutral-500')
                  " />
              }

              @case ('schedules') {
                <lib-timer-icon
                  [iconClass]="
                    'size-4 ' +
                    (currentTabIndex() === index
                      ? 'text-primary-500'
                      : 'text-neutral-500')
                  " />
              }
            }
          </ng-template>

          @switch (tab.key) {
            @case ('history') {
              <lib-history-tab
                [permissions]="requestDetailsResponse().data.permissions"
                [workflowName]="requestDetailsResponse().data.name" />
            }

            @case ('reports') {
              <lib-reports-tab
                [active]="currentTabIndex() === index"
                [requestId]="requestId()" />
            }

            @case ('requirements') {
              <lib-requirement-tab [requirements]="requirements()" />
            }

            @case ('steps-diagram') {
              <lib-step-diagram-tab
                [active]="currentTabIndex() === index"
                [positions]="stepsDiagramPositions()"
                [tags]="requestTags()"
                (tagsChanged)="onTagsChanged($event)"
                [requestName]="
                  requestDetailsResponse()
                    .data.name.split(' ')
                    .join('_')
                    .toLocaleLowerCase()
                " />
            }
            @case ('schedules') {
              @if (currentTabIndex() === index) {
                <lib-schedules-tab
                  [requestId]="requestId()"
                  [userPermissions]="
                    requestDetailsResponse().data.permissions
                  " />
              }
            }
          }
        </lib-tab>
      }
    </lib-tabs>
  }
</div>
